import _defineProperty from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/rewards/tag_used.png';
import _imports_1 from '@/assets/images/rewards/tag_expired.png';
import _imports_2 from '@/assets/images/rewards/coupon_bg.png';
import _imports_3 from '@/assets/images/right_arrow_gray.svg';
var _hoisted_1 = {
  class: "list-content"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  key: 0,
  class: "mask"
};
var _hoisted_4 = {
  key: 1,
  class: "tag",
  src: _imports_0,
  alt: ""
};
var _hoisted_5 = {
  key: 2,
  class: "tag",
  src: _imports_1,
  alt: ""
};
var _hoisted_6 = {
  class: "rewards-content"
};
var _hoisted_7 = {
  class: "rewards-info"
};
var _hoisted_8 = {
  class: "rewards-title"
};
var _hoisted_9 = {
  class: "rewards-desc"
};
var _hoisted_10 = {
  class: "time"
};
import PoweredBy from "@/components/PoweredBy.vue";
import { ref } from "vue";
import { getMyProduct, getUserCouponList } from "@/api/reward";
import EmptyListPlaceholder from "../EmptyListPlaceholder.vue";
import { useOrder } from "@/hooks/useOrder";
import { formatDateWithTZ, formatPercent } from "@/utils/format";
import { CouponStatusEnum, DiscountTypeEnum } from "@/constant/coupon";
import { getSupplyId, getUserId } from "@/utils/authUtil";
import { useI18n } from "vue-i18n";
var maxExpiredDay = 3;
export default {
  __name: 'MyRewardList',
  props: {
    type: {
      type: String,
      default: "unused"
    }
  },
  emits: ["item-click"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var emit = __emit;
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var loading = ref(false);
    var finished = ref(false);
    var pageNum = ref(1);
    var pageSize = ref(20);
    var rewardList = ref([]);
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getUserCouponList({
                page_num: pageNum.value,
                page_size: pageSize.value,
                company_id: getSupplyId(),
                status_list: props.type === "history" ? [CouponStatusEnum.EXPIRED, CouponStatusEnum.USED] : [CouponStatusEnum.UNUSED, CouponStatusEnum.INEFFECTIVE],
                user_id: getUserId(),
                search_mode: 2
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = res.data.items || [];
                if (data.length > 0) {
                  rewardList.value = rewardList.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var genValidTime = function genValidTime(item) {
      if (item.status === CouponStatusEnum.INEFFECTIVE) {
        return t("effectiveTheNextDay");
      }
      if (item.status === CouponStatusEnum.UNUSED) {
        var days = diffDay(item);
        if (days <= maxExpiredDay) {
          return t("expiresInNDays", [days]);
        }
      }
      return t("validUntilN", [formatDateWithTZ(item.end_time, "YYYY-MM-DD")]);
    };
    var diffDay = function diffDay(item) {
      return Math.ceil((item.end_time - Date.now()) / (24 * 60 * 60 * 1000));
    };
    var genTitle = function genTitle(item) {
      var couponInfo = item.coupon;
      return item.title || couponInfo.title;
    };
    var toDetail = function toDetail(item) {
      emit("item-click", _objectSpread({
        title: item.title || item.coupon.title,
        coupon_info: _objectSpread({
          using_time_rule: item.using_time_rule
        }, item.coupon)
      }, item));
    };
    var refresh = function refresh() {
      finished.value = false;
      rewardList.value = [];
      pageNum.value = 1;
    };
    __expose({
      refresh: refresh
    });
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createBlock(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
          return loading.value = $event;
        }),
        class: "my-reward-list",
        finished: finished.value,
        "loading-text": _ctx.$t('loading'),
        onLoad: fetchData
      }, {
        default: _withCtx(function () {
          return [!loading.value && rewardList.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
            key: 0,
            text: _ctx.$t('youHaveNoVouchersYet'),
            class: "empty",
            onGo: _unref(toOrderView)
          }, null, 8, ["text", "onGo"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rewardList.value, function (item, i) {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["rewards-item", _defineProperty(_defineProperty(_defineProperty({}, item.status, true), 'van-haptics-feedback', item.status !== _unref(CouponStatusEnum).USED && item.status !== _unref(CouponStatusEnum).EXPIRED), 'almost-expired', item.status === _unref(CouponStatusEnum).UNUSED && diffDay(item) <= maxExpiredDay)]),
              onClick: function onClick($event) {
                return toDetail(item);
              }
            }, [item.status !== _unref(CouponStatusEnum).UNUSED ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true), item.status === _unref(CouponStatusEnum).USED ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), item.status === _unref(CouponStatusEnum).EXPIRED ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "rewards-img",
              src: _imports_2,
              alt: ""
            }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, _toDisplayString(genTitle(item)), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.coupon.description), 1)])]), _createElementVNode("div", _hoisted_10, _toDisplayString(genValidTime(item)), 1)]), _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_3
            }, null, -1))], 10, _hoisted_2);
          }), 128))]), finished.value ? (_openBlock(), _createBlock(PoweredBy, {
            key: 1,
            "is-list": true
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "finished", "loading-text"]);
    };
  }
};